import React from 'react';

function InstrumentValue() {
  return <div>--</div>;
}

export default InstrumentValue;



// WEBPACK FOOTER //
// ./src/components/InstrumentValue.jsx